import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CardLinkWithGAClickButton,
  CardMedia,
  MediaCard,
  MediaCardContent,
  MediaCardTitle,
  MediaCardDescription,
  Typography,
  Section,
  SectionSubTitle,
  SectionTitle,
} from 'common/components';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { createElementKey } from 'utils';
import { BATHROOM_CDN_PATH } from '../../old-bathroom-constants';
import { ASSORTMENT_SECTION_CARD_LIST } from './assortment-section-constants';
import {
  assortmentSection,
  cardMediaStyle,
  DownloadCatalog,
  DownloadCatalogContent,
  DownloadCatalogImage,
  descriptionStyle,
  downloadCatalogSizeStyle,
  downloadCatalogTitleStyle,
  StyledCardGrid,
} from './assortment-section-styles';
import { AssortmentSectionCardStructure } from './assortment-section-types';

/**
 * Вью секции асортимента
 */
export const AssortmentSection = ({ regionId }: { regionId: string }) => {
  const { t } = useTranslation();

  return (
    <Section className={assortmentSection}>
      <SectionTitle>{t('assortment-section.title-main')}</SectionTitle>
      <div>
        <SectionSubTitle adaptiveMargin margin="s" as="h3">
          {t('assortment-section.title-second')}
        </SectionSubTitle>
        <Typography className={descriptionStyle} size="body_long" variant="m">
          {t('assortment-section.description')}
        </Typography>

        <StyledCardGrid>
          {ASSORTMENT_SECTION_CARD_LIST.map(({ link, card }: AssortmentSectionCardStructure, index) => (
            <CardLinkWithGAClickButton
              elementBlock="landingVannuyuKomnatu"
              elementName={card.content.title}
              elementText={t('assortment-section.title-second')}
              href={link.href}
              title={t(link.title)}
              key={createElementKey('assortment-card', index)}
              rel="noreferrer">
              <MediaCard>
                <CardMedia
                  className={cardMediaStyle}
                  loading="lazy"
                  src={card.media.src}
                  alt={t(card.media.alt) || ''}
                />
                <MediaCardContent>
                  <MediaCardTitle>{t(card.content.title)}</MediaCardTitle>
                  {card.content.description && (
                    <MediaCardDescription>{t(card.content.description)}</MediaCardDescription>
                  )}
                </MediaCardContent>
              </MediaCard>
            </CardLinkWithGAClickButton>
          ))}
        </StyledCardGrid>
        {regionId !== KAZAKHSTAN && (
          <DownloadCatalog
            download
            elementBlock="landingVannuyuKomnatu"
            elementName={t('assortment-section.catalog.title')}
            elementText={t('assortment-section.title-second')}
            href="https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/bathroom/Catalog-vannye-v2.pdf"
            rel="noreferrer"
            target="_blank"
            title={t('assortment-section.catalog.link-title')}>
            <DownloadCatalogContent>
              <Typography adaptive={false} className={downloadCatalogTitleStyle} size="subtitle" variant="m">
                {t('assortment-section.catalog.title')}
              </Typography>
              <Typography color="text-secondary" className={downloadCatalogSizeStyle} variant="caption">
                PDF, 24&nbsp;МБ
              </Typography>
            </DownloadCatalogContent>
            <DownloadCatalogImage
              alt={t('assortment-section.catalog.icon-alt') || ''}
              title={t('assortment-section.catalog.link-title') || ''}
              src={`${BATHROOM_CDN_PATH}/assortment/catalog-link-new.png/catalog-link-new.png`}
            />
          </DownloadCatalog>
        )}
      </div>
    </Section>
  );
};
